// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsPricingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetApplicationPaymentRequirementWebApiResponseDto, ListingAlias } from '../..';

interface GetApplicationPaymentRequirementParams {
  applicationId: string;
}
interface GetApplicationSharingEnabledParams {
  listingAlias?: ListingAlias;
}

export const CappsPricingWebApiHandler_getApplicationPaymentRequirement_Path =
  '/api/web/renter/v1/payment/getApplicationPaymentRequirement';

export const CappsPricingWebApiHandler_getApplicationPaymentRequirement = (
  getParams: GetApplicationPaymentRequirementParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetApplicationPaymentRequirementParams,
    never,
    GetApplicationPaymentRequirementWebApiResponseDto
  >(
    {
      getParams: getParams,
      endpoint: CappsPricingWebApiHandler_getApplicationPaymentRequirement_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsPricingWebApiHandler_getApplicationSharingEnabled_Path =
  '/api/web/renter/v1/payment/getApplicationSharingEnabled';

export const CappsPricingWebApiHandler_getApplicationSharingEnabled = (
  getParams: GetApplicationSharingEnabledParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetApplicationSharingEnabledParams, never, boolean>(
    {
      getParams: getParams,
      endpoint: CappsPricingWebApiHandler_getApplicationSharingEnabled_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
